import React from "react"
import styled from "styled-components"
import { P, Title } from "@motorata/base-ui.components.atoms.typography";
import { blockStyles } from "@motorata/base-ui.components.atoms._atoms";
import Link from "@motorata/next.components.atoms.link";
import { NextImage } from "../common/Image";

const FinanceBlock = ({ icon, title, text, link }) => {
  return (
    <BlockWrapper>
      <IconWrapper>
        <NextImage
          priority={true}
          fill
          alt={`Grafika finansowania ${title}`}
          src={`/images/${icon}`}
        />
      </IconWrapper>
      <Title type="secondary" elementType="label">{title}</Title>
      <P small textAlign="center">
        {text}
      </P>
      <Link href={link} type="third">Zobacz więcej</Link>
    </BlockWrapper>
  )
}

const FinanceTypesSection = () => {
  return (
    <Wrapper>
      <Title label="FINANSOWANIE" center>
        Dowiedz się więcej na temat finansowań
      </Title>
      <Content>
        <FinanceBlock
          icon="donut-chart.png"
          title="Leasing"
          text="Leasing jest najpopularniejszym sposobem finansowania nowych samochodów przez przedsiębiorstwa. "
          link="/leasing"
        />
        {/*<FinanceBlock*/}
        {/*  icon="coins.png"*/}
        {/*  title="Pożyczka"*/}
        {/*  text="Pożyczka lesingowa umożliwia przedsiębiorstwą finansowanie nowych oraz używanych samochodów."*/}
        {/*/>*/}
        <FinanceBlock
          icon="credit-card.png"
          title="Kredyt"
          text="Kredyt stanowi podstawową forme finansowania samochodów przez osoby prywatne."
          link="/kredyt"
        />
      </Content>
    </Wrapper>
  )
}

export default FinanceTypesSection

const IconWrapper = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  margin-bottom: ${({ theme }) => theme.space.M};
  
  img{
    object-fit: contain;
  }
`

const BlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  margin: ${({ theme }) => theme.space.M};
`

const Content = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
`

const Wrapper = styled.div`
  ${blockStyles};
`
